"use client";

import "./start-verifying-renters-button.css";
import { ArrowRight } from "lucide-react";

export default function StartVerifyingRentersButton({ size }) {
  const isSmall = size === "small";

  return (
    <a
      className="start-verifying-button"
      href="https://rent-id.io/sign-in"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="start-verifying-button__glow" aria-hidden="true" />
      <span
        className={`start-verifying-button__content ${
          isSmall
            ? "start-verifying-button__content--small"
            : "start-verifying-button__content--large"
        }`}
      >
        Start Verifying Renters
        <ArrowRight className="start-verifying-button__icon" />
      </span>
    </a>
  );
}
